import Slideshow from "../../classes/Slideshow";
import {trigger} from "../../../utils/events/trigger";

export const initCarousel = () => {
	const components = Array.from(document.querySelectorAll('section.carousel'));
	
	if ( components.length )
	{
		components.forEach( ( component ) => {
			const sliders = Array.from(component.querySelectorAll('div.slideshow'));
			const breakpoint = 956;
			
			if ( !sliders.length )
			{
				return;
			}
			
			sliders.forEach( ( it ) => {
				const bookmarksContainer = it.querySelector('ul.buttons');
				const slidesContainer = it.querySelector('ul.slides');
				const navsContainer = it.querySelector('ul.nav');

				if ( bookmarksContainer || navsContainer)
				{
					const slider = new Slideshow({
						slidesContainer,
						bookmarksContainer,
						navsContainer,
					});

					if ( window.innerWidth < breakpoint )
					{
						slider.destroy();
					}

					const toggleSlider = () => {
						if ( window.innerWidth < breakpoint )
						{
							slider.destroy();
						} else
						{
							slider.rebuild();
						}
					}

					window.addEventListener( 'resize', toggleSlider );
				}
			} );

			const header = component.querySelector( 'div.header' );

			if ( header )
			{
				const checkHeader = () => {
					if ( header.querySelector( 'div.tabs' ).getBoundingClientRect().width < header.querySelector( 'ul' ).getBoundingClientRect().width )
					{
						header.classList.add( 'scrollable' );
					}
				};

				checkHeader();
				window.addEventListener( 'resize', checkHeader );
			}

			if ( !component.classList.contains( 'apartments' ) )
			{
				return;
			}

			component.addEventListener( 'change', ( evt ) => {
				const currentID = evt.target.id;

				Array.from(component.querySelectorAll( 'div.header > div.tabs > ul > li.current, div.slideshow.current' )).forEach( ( it ) => {
					it.classList.remove( 'current' );
				} );

				if ( component.querySelector( `label[for="${currentID}"]` ) )
				{
					component.querySelector( `label[for="${currentID}"]` ).parentNode.classList.add( 'current' );
				}

				component.querySelector( `div.slideshow[data-id="${currentID}"]` ).classList.add( 'current' );
			} );

			const firstOption = component.querySelector( 'input:first-child' );

			trigger( firstOption, 'change', true );
		});
	}
}
